// extracted by mini-css-extract-plugin
export default {"Subpage":"basicStatistics_Subpage__Bt+ah","TopFivePatternsContainer":"basicStatistics_TopFivePatternsContainer__X3c5L"};